import { render, staticRenderFns } from "./ShippingLabels.vue?vue&type=template&id=db7bcebc&"
import script from "./ShippingLabels.vue?vue&type=script&lang=js&"
export * from "./ShippingLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports